import { render, staticRenderFns } from "./SocialMediaModal.vue?vue&type=template&id=ba7ba3d4&scoped=true&"
import script from "./SocialMediaModal.vue?vue&type=script&lang=js&"
export * from "./SocialMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7ba3d4",
  null
  
)

export default component.exports